var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGasLeak(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Flat"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m96 312h48v64h-48z",
    fill: "#efdd9b"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 240,
    fill: "#8bcde8",
    r: 88
  }), /*#__PURE__*/React.createElement("path", {
    d: "m112 166.667h16v33.333h-16z",
    fill: "#efbf33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m71.858 183.088h16v33.539h-16z",
    fill: "#efbf33",
    transform: "matrix(.707 -.707 .707 .707 -117.931 115.005)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m142.717 190.274h38.018v16h-38.018z",
    fill: "#efbf33",
    transform: "matrix(.707 -.707 .707 .707 -92.832 172.419)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m120 152a88 88 0 1 0 88 88 88.0013 88.0013 0 0 0 -88-88zm0 152a64 64 0 1 1 64-64 63.99511 63.99511 0 0 1 -64 64z",
    fill: "#2f4054"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m75.215 244h48v15.999h-48z",
    fill: "#e54042",
    transform: "matrix(.866 -.5 .5 .866 -112.713 83.375)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 240,
    fill: "#2f4054",
    r: 16
  }), /*#__PURE__*/React.createElement("path", {
    d: "m56 376h400v96h-400z",
    fill: "#efdd9b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24 360h32v128h-32z",
    fill: "#e54042"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m456 360h32v128h-32z",
    fill: "#e54042"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m184 16v8a24 24 0 0 0 24 24h76a36 36 0 0 1 36 36 36 36 0 0 1 -36 36h-4.0001a55.99994 55.99994 0 0 0 -55.9999 55.99994v.00012a55.99994 55.99994 0 0 0 55.99994 55.99994h8.00384a19.9962 19.9962 0 0 1 19.99622 20 20.00376 20.00376 0 0 1 -20.00376 20h-19.712a28.28425 28.28425 0 0 0 -28.28424 28.28424 28.28425 28.28425 0 0 0 8.28426 20l55.71574 55.71576v-48a23.998 23.998 0 0 1 24-23.998l56.8953.00487a31.07743 31.07743 0 0 0 31.08008-31.102l-.0016-2.03189a30.899 30.899 0 0 0 -30.9014-30.87457l-2.25524.00017a38.80575 38.80575 0 0 1 -38.80874-38.79007l-.00048-1.19983a39.99255 39.99255 0 0 1 39.99254-40.00868h39.9996a63.99994 63.99994 0 0 0 63.99994-63.99994v-80.00006z",
    fill: "#c5d5e1"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#a7b3bd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m328 224h-16v-12a12.01343 12.01343 0 0 0 -12-12h-20a24 24 0 0 1 0-48h24v16h-24a8 8 0 0 0 0 16h20a28.03146 28.03146 0 0 1 28 28z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m320 152h16v16h-16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m360 144h-16v-15a33.03734 33.03734 0 0 1 33-33h30a17.019 17.019 0 0 0 17-17v-15h16v15a33.03734 33.03734 0 0 1 -33 33h-30a17.019 17.019 0 0 0 -17 17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m424 32h16v16h-16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m320 272h16v16h-16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m360 288h-16v-16h16a8.00917 8.00917 0 0 0 8-8v-8h16v8a24.02718 24.02718 0 0 1 -24 24z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m317.65991 421.66016-16 16-11.31982-11.32032 10.34985-10.33984-18.34985-18.33984a8.01538 8.01538 0 0 1 0-11.32032l10.33984-10.33984h22.64014l-16.01 16 18.34985 18.33984a8.01538 8.01538 0 0 1 -.00001 11.32032z",
    fill: "#efbf33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m96 360h48v16h-48z",
    fill: "#efbf33"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGasLeak);
export default __webpack_public_path__ + "static/media/gas_leak.7a6236ccc8574f56f68ac1d82eea607b.svg";
export { ForwardRef as ReactComponent };